import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'teclado',
    template: require('./teclado.component.html'),
    styles: [require('./teclado.component.css')]
})
export class TecladoComponent implements OnInit 
{ 
    @Output() onDigitacao = new EventEmitter();
    
    @Input()
    set exibir(exibir: boolean) {
        const teclado = document.getElementById('teclado');
        
        if(exibir) {
            teclado.classList.remove('hidden');
        } else {
            teclado.classList.add('hidden');            
        }
    }

    ngOnInit() {

    }   

    onInteraction(event: Event) {
        event.stopPropagation();        
    }

    digitar(event: Event, valor: string) {
        event.stopPropagation();
        this.onDigitacao.emit(valor);
    }

    onMouseDown(event: Event) {
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/pesquisa-touch/teclado/teclado.component.ts
 **/